import { getQueryClient } from '@/lib/queryClientHolder';
import { queryKeys } from '@/lib/queryKeys';
import { useOrganizationStore } from '@/stores/organizationStore';
import type { Organization } from '@/types';
import type { OrganizationMembership } from '@/types';

interface OrganizationQueryData {
  organization: Organization | null;
  membership: OrganizationMembership | null;
}

/**
 * Bridge for non-React code (haciendaClient, salesService) to read active
 * organization data from TanStack Query cache (source of truth).
 *
 * Reads the client through queryClientHolder rather than importing it: a direct
 * import creates a module cycle (queryClient → offlineMutations → haciendaService
 * → organizationBridge → queryClient) that crashes at init depending on load order.
 */
function getOrganizationQueryData(): OrganizationQueryData | undefined {
  const slug = useOrganizationStore.getState().currentOrganizationSlug;
  if (!slug) return undefined;

  return getQueryClient()?.getQueryData<OrganizationQueryData>(queryKeys.organization(slug));
}

export function getCurrentOrganization(): Organization | null {
  return getOrganizationQueryData()?.organization ?? null;
}

export function getCurrentMembership(): OrganizationMembership | null {
  return getOrganizationQueryData()?.membership ?? null;
}
